import { ref } from 'vue'
import { onWaitingAlert, type WaitingAlertNotification } from '@/composables/useConversationRealtime'
import { showPushNotification } from '@/services/notifications'

// Alerta "conversas esperando atendente" — o backend manda pro grupo "painel" (administradores)
// quando uma conversa roteada passa do limite sem agente (Configurações › Atendimento). Estado de
// módulo (singleton), como useAssignmentAlert.ts: WaitingAlertBanner.vue só lê.
export const waitingAlert = ref<WaitingAlertNotification | null>(null)

let unsubscribe: (() => void) | null = null

export function alertTitle(alert: WaitingAlertNotification): string {
  return alert.count === 1
    ? `1 conversa esperando atendente há mais de ${alert.thresholdMinutes} min`
    : `${alert.count} conversas esperando atendente há mais de ${alert.thresholdMinutes} min`
}

/** Alertas novos enquanto o anterior está na tela somam no mesmo aviso (mesma conversa não conta duas vezes). */
export function pushWaitingAlert(alert: WaitingAlertNotification): void {
  const current = waitingAlert.value
  if (!current) {
    waitingAlert.value = alert
    return
  }
  const known = new Set(current.conversations.map(c => c.conversationId))
  const added = alert.conversations.filter(c => !known.has(c.conversationId))
  waitingAlert.value = {
    ...alert,
    count: current.count + added.length,
    conversations: [...current.conversations, ...added],
  }
}

export function dismissWaitingAlert(): void {
  waitingAlert.value = null
}

export function startWaitingAlerts(): void {
  if (unsubscribe) return
  unsubscribe = onWaitingAlert(alert => {
    pushWaitingAlert(alert)
    const names = alert.conversations.slice(0, 3).map(c => c.contactName).join(', ')
    void showPushNotification(alertTitle(alert), `Ninguém do time nem do fallback disponível. ${names}`, '/fila', 'espera-sem-agente')
  })
}

export function stopWaitingAlerts(): void {
  unsubscribe?.()
  unsubscribe = null
  waitingAlert.value = null
}
